/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Payment_Amount_Exceeds_RemainingInputs */

const vi_payment_amount_exceeds_remaining = /** @type {(inputs: Payment_Amount_Exceeds_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số tiền không được vượt số còn phải thu (${i?.max} ₫)`)
};

/**

* @param {Payment_Amount_Exceeds_RemainingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_amount_exceeds_remaining = /** @type {((inputs: Payment_Amount_Exceeds_RemainingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Amount_Exceeds_RemainingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_amount_exceeds_remaining(inputs)
});